import { render, staticRenderFns } from "./InputStockArticlesPage.vue?vue&type=template&id=b5871af8"
import script from "./InputStockArticlesPage.vue?vue&type=script&lang=js"
export * from "./InputStockArticlesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports